//export const baseUrl = 'http://44.195.83.148/backend/public/api'
export const baseUrl = 'https://certificatesglobal.com/api'
//export const baseUrl = 'http://localhost/nsbNew/public/api'